import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import type { TPreparationStatus } from 'src/store/well-pad-preparation/types';

import styles from './status-label.module.scss';

type Props = {
  status: TPreparationStatus;
};

const defaultStatusData = {
  ready: 'Готово',
  inProcess: 'В процессе',
  notReady: 'Не готово',
};

export const StatusLabel = observer<Props>(function StatusLabel({ status }) {
  const { t } = useTranslation();

  return (
    <div className={clsx(styles.wrapper, styles[`wrapper_${status}`])}>
      <p>{t(defaultStatusData[status])}</p>
    </div>
  );
});
